import { Outlet } from "react-router-dom";

// Partner pages are viewable regardless of registration status — only
// write actions (Add/Edit/Delete) are gated, via useRegistrationGuard /
// ActionGuardModal at the point of action. This wrapper is kept as a no-op
// pass-through (rather than removed from App.js) so the route tree doesn't
// need to change if page-level gating is ever reintroduced.
const PartnerRegistrationGate = () => <Outlet />;

export default PartnerRegistrationGate;
